/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { CampaignWrapperRequestToJSON, CampaignWrapperResponseFromJSON, PagedResponseOfCampaignWrapperListEntryFromJSON, } from '../models';
/**
 *
 */
var CampaignWrapperRestControllerApi = /** @class */ (function (_super) {
    __extends(CampaignWrapperRestControllerApi, _super);
    function CampaignWrapperRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new campaignWrapper <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     * Create a new campaignWrapper <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.createCampaignWrapperRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignWrapperRequest === null || requestParameters.campaignWrapperRequest === undefined) {
                            throw new runtime.RequiredError('campaignWrapperRequest', 'Required parameter requestParameters.campaignWrapperRequest was null or undefined when calling createCampaignWrapper.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignWrapperRequestToJSON(requestParameters.campaignWrapperRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignWrapperResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new campaignWrapper <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     * Create a new campaignWrapper <p> \'Permission#CREATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.createCampaignWrapper = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCampaignWrapperRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete campaignWrapper <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     * Delete campaignWrapper <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.deleteCampaignWrapperRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignWrapperId === null || requestParameters.campaignWrapperId === undefined) {
                            throw new runtime.RequiredError('campaignWrapperId', 'Required parameter requestParameters.campaignWrapperId was null or undefined when calling deleteCampaignWrapper.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers/{campaignWrapperId}".replace("{".concat("campaignWrapperId", "}"), encodeURIComponent(String(requestParameters.campaignWrapperId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete campaignWrapper <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     * Delete campaignWrapper <p> \'Permission#DELETE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.deleteCampaignWrapper = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCampaignWrapperRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get campaignWrapper details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * Get campaignWrapper details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.getCampaignWrapperRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignWrapperId === null || requestParameters.campaignWrapperId === undefined) {
                            throw new runtime.RequiredError('campaignWrapperId', 'Required parameter requestParameters.campaignWrapperId was null or undefined when calling getCampaignWrapper.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers/{campaignWrapperId}".replace("{".concat("campaignWrapperId", "}"), encodeURIComponent(String(requestParameters.campaignWrapperId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignWrapperResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get campaignWrapper details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * Get campaignWrapper details <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.getCampaignWrapper = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCampaignWrapperRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List campaignWrappers using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * List campaignWrappers using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.listCampaignWrappersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfCampaignWrapperListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List campaignWrappers using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     * List campaignWrappers using pagination <p> \'Permission#READ_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.listCampaignWrappers = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listCampaignWrappersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch campaignWrapper (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint. A campaignWrapper may update only itself.
     * Patch campaignWrapper (partial update).
     */
    CampaignWrapperRestControllerApi.prototype.patchCampaignWrapperRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignWrapperId === null || requestParameters.campaignWrapperId === undefined) {
                            throw new runtime.RequiredError('campaignWrapperId', 'Required parameter requestParameters.campaignWrapperId was null or undefined when calling patchCampaignWrapper.');
                        }
                        if (requestParameters.campaignWrapperRequest === null || requestParameters.campaignWrapperRequest === undefined) {
                            throw new runtime.RequiredError('campaignWrapperRequest', 'Required parameter requestParameters.campaignWrapperRequest was null or undefined when calling patchCampaignWrapper.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers/{campaignWrapperId}".replace("{".concat("campaignWrapperId", "}"), encodeURIComponent(String(requestParameters.campaignWrapperId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignWrapperRequestToJSON(requestParameters.campaignWrapperRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignWrapperResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch campaignWrapper (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint. A campaignWrapper may update only itself.
     * Patch campaignWrapper (partial update).
     */
    CampaignWrapperRestControllerApi.prototype.patchCampaignWrapper = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchCampaignWrapperRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update campaignWrapper <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     * Update campaignWrapper <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.updateCampaignWrapperRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.campaignWrapperId === null || requestParameters.campaignWrapperId === undefined) {
                            throw new runtime.RequiredError('campaignWrapperId', 'Required parameter requestParameters.campaignWrapperId was null or undefined when calling updateCampaignWrapper.');
                        }
                        if (requestParameters.campaignWrapperRequest === null || requestParameters.campaignWrapperRequest === undefined) {
                            throw new runtime.RequiredError('campaignWrapperRequest', 'Required parameter requestParameters.campaignWrapperRequest was null or undefined when calling updateCampaignWrapper.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/campaignwrappers/{campaignWrapperId}".replace("{".concat("campaignWrapperId", "}"), encodeURIComponent(String(requestParameters.campaignWrapperId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CampaignWrapperRequestToJSON(requestParameters.campaignWrapperRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CampaignWrapperResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update campaignWrapper <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     * Update campaignWrapper <p> \'Permission#UPDATE_CAMPAIGN\' is required to access to this endpoint
     */
    CampaignWrapperRestControllerApi.prototype.updateCampaignWrapper = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCampaignWrapperRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CampaignWrapperRestControllerApi;
}(runtime.BaseAPI));
export { CampaignWrapperRestControllerApi };
